import styled from '@emotion/styled';
import { FormHelpText } from '@spotify-internal/encore-web';

export const BottomSection = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const CharacterCount = styled(FormHelpText)`
  flex: 1;
`;
